import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2ColourSwatchOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="M8.008 24.57v1.997H6.007V24.57zm16.6-10.731 1.74 3.446-2.79 1.545-.155 2.368L29 18.1l-3.506-6.95-18.961 9.59L17.249 7.391l3.032 2.21-1.492 1.96.783 2.272 3.537-4.646-6.225-4.534L5.46 18.883 7.742 4.717l3.816.47-.264 1.821 1.818 1.273.018.003.703-4.832-7.76-.953L3.01 21.51 3 29.5h25.02v-7.99H9.44zm1.411 9.668v3.995H5.002v-3.995z" /></svg>
);
